export default __webpack_public_path__ + "static/media/Group1483@2x.e1addb93.png";